import React from 'react'
import { Box, TextField, Button, MenuItem } from '@mui/material';
import MobileSearchAdornment from '../../common/search/MobileSearchAdornment';


const NoticeListBox = ({ formik }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'center',
                my: 1,
            }}
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                sx={{
                    flexGrow: 1,
                    display: { xs: 'contents', sm: 'flex' },
                    flexDirection: 'row',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                    alignItems: 'center',
                    rowGap: 1,
                    mr: 2,
                }}
                onSubmit={formik.handleSubmit}
            >
                <Box
                    sx={{
                        order: { xs: 1, sm: 0 },
                        flex: { xs: 1, sm: '0 1 auto' },
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'nowrap',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
                        '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
                        '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
                    }}
                >
                    <TextField
                        variant="standard"
                        required={false}
                        select
                        id="searchKeyword"
                        name="searchKeyword"
                        label="검색키워드"
                        value={formik.values.searchKeyword}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.searchKeyword &&
                            Boolean(formik.errors.searchKeyword)
                        }
                        helperText={
                            formik.touched.searchKeyword && formik.errors.searchKeyword
                        }
                    >
                        <MenuItem value="">검색키워드</MenuItem>
                        <MenuItem value="wrTitle">제목</MenuItem>
                        <MenuItem value="wrContent">내용</MenuItem>
                        <MenuItem value="crtNm">작성자</MenuItem>
                    </TextField>
                    <TextField
                        variant="standard"
                        required={false}
                        id="searchWords"
                        name="searchWords"
                        label="검색어"
                        onChange={formik.handleChange}
                        error={
                            formik.touched.searchWords && Boolean(formik.errors.searchWords)
                        }
                        helperText={
                            formik.touched.searchWords && formik.errors.searchWords
                        }
                        InputProps={{
                            endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
                        }}
                    />
                </Box>

                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Button
                        type="submit"
                        color="info"
                        variant="contained"
                        disabled={formik.isSubmitting}
                    >
                        검색
                    </Button>
                </Box>
            </Box>

        </Box>
    )
}

export default NoticeListBox